<ion-app>
  <ion-split-pane when="(min-width: 1500px)" contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" [disabled]="hideSplitPane">
      <ion-content>
        <ion-row class="ion-justify-content-center">
          <div class="bg-logo-dark logo-size"></div>
        </ion-row>
        <!-- Entreprise -->
        <app-employer-select></app-employer-select>
        <ion-list id="enterprise-list">
          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'map'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" [ios]="'business-outline'" [md]="'business-sharp'"></ion-icon>
              <ion-label>{{'NAV.DASHBOARD'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle  *ngIf="hasJobReadGrant && !isDriver" auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'jobs'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" [ios]="'list-outline'" [md]="'list-sharp'"></ion-icon>
              <ion-label>{{'NAV.ACTIVITIES'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="hasCustomerReadGrant && !isDriver" auto-hide="false">
            <ion-item  routerDirection="root" [routerLink]="'customers'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="assignment-ind"></ion-icon>
              <ion-label>{{'NAV.CUSTOMERS'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="hasEmployeeReadGrant && !isDriver" auto-hide="false">
            <ion-item  routerDirection="root" [routerLink]="'employees'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" [ios]="'people-outline'" [md]="'people-sharp'"></ion-icon>
              <ion-label>{{'NAV.EMPLOYEES'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="hasMachineReadGrant && !isDriver" auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'machines'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="tractor"></ion-icon>
              <ion-label>{{'NAV.MACHINES'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="hasImplementReadGrant && !isDriver" auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'implements'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="implement"></ion-icon>
              <ion-label>{{'NAV.IMPLEMENTS'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="hasFieldReadGrant && !isDriver" auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'fields'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="apps-sharp"></ion-icon>
              <ion-label>{{'NAV.FIELDS'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="hasLocationReadGrant && !isDriver" auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'locations'" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="room"></ion-icon>
              <ion-label>{{'NAV.LOCATIONS'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <!-- User  -->
        <ion-list id="user-list">
          <ion-list-header>{{'NAV.MY_SECTION'|translate}}</ion-list-header>
          <ion-note class="user-settings" >{{username}}
          <!--   <ion-button style="transform: scale(0.8); margin-left: 10%" size="small" (click)="openSettings()">
              <ion-icon name="settings-outline"></ion-icon>
            </ion-button> -->
          </ion-note>
          <ion-menu-toggle auto-hide="false">
            <ion-item button (click)="onClickLogout()" lines="none" detail="false">
              <ion-icon slot="start" [ios]="'exit-outline'" [md]="'exit-sharp'"></ion-icon>
              <ion-label>{{'LOG_OUT'|translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
